import {Component, OnInit, OnDestroy} from '@angular/core';
import {MenuItem} from './menu-items.module';
import {LocalStorageService} from '../share/localstorage.service';
import {SyncService} from '../share/sync.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})

export class MenuComponent implements OnInit, OnDestroy {
    public MenuItems: MenuItem[] = [];
    public Ueberschrift = '';
    public Hinweis = '';
    public App_Version = '';
    public releasenotes = '';

    private subscription: any = null;
    constructor(private ls: LocalStorageService, private syncservice: SyncService) {

    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.subscription  = null;
    }

    getGrunddata() {
        this.Ueberschrift = this.ls.get('APP_Ueberschrift');
        this.App_Version = 'V' + this.ls.get('app_version');
        if (this.Ueberschrift === null) {
            setTimeout(() => {
                this.getGrunddata();
            }, 250);
        }
    }

    ngOnInit() {

        this.Ueberschrift = this.ls.get('APP_Ueberschrift');
        this.App_Version = 'V' + this.syncservice.getAppVersion();
        this.releasenotes = 'V'+ this.ls.get('releasenotes');


        document.getElementById('menu_background').style.backgroundImage = './assets/images/bg.jpg';


        this.MenuItems.push(new MenuItem('POCSAG', 'form', '/pocsag', 0, 0));

        this.MenuItems.push(new MenuItem('FAHRZEUGE', 'car', '/fahrzeuge', 0, 0));
        this.MenuItems.push(new MenuItem('FAHRZEUG STANDORTE', 'map', '/standort', 0, 0));


        //this.setMenuNumbers('Hinweis', '3', '');


        if (this.subscription == null) {

            this.subscription = this.syncservice.neueMenuNumbers
                .subscribe(
                    (data:string) => {
                        const yellow = data.substring(data.search('@')+1,data.search('#'));
                        const red = data.substring(data.search('#')+1);
                        console.log(data.substring(0,(data.search('@'))),yellow, red);
                        this.setMenuNumbers(data.substring(0,(data.search('@'))),yellow, red);
                    }
                )
        }

        this.syncservice.sync('initial');
    }





    public setMenuNumbers(item: string, number_yellow: string, number_red: string) {
        if (item == 'Hinweis' && number_yellow !== '') {
            this.Ueberschrift = '';
            this.ls.store('status', number_yellow);
            this.Hinweis = number_yellow;
        } else if (item == 'Hinweis' && number_yellow === '') {
            this.ls.store('status', number_yellow);
        } else {
            for (let i = 0; i < this.MenuItems.length; i++) {
                if (this.MenuItems[i].bebschreibung === item) {
                    this.MenuItems[i].newsitems_red = parseInt(number_red);
                    this.MenuItems[i].newsitems = parseInt(number_yellow);
                }
            }
        }
    }
}
